import React, { FC } from 'react';
import { Share } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import {
  OKIcon,
  OKShareButton,
  TelegramIcon,
  VKIcon,
  VKShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share';

interface Props {
  url: string;
  description: string;
  title: string;
  size?: number;
}

const ShareButton: FC<Props> = ({ url, description, title, size = 32 }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton onClick={handleClick} edge="end">
        <Share />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleClose}>
          <VKShareButton
            url={`${url}&utm_source=vk`}
            title={title}
            windowWidth={660}
            windowHeight={460}
            className="pointer"
          >
            <div>
              <VKIcon size={size} round />
            </div>
          </VKShareButton>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <OKShareButton
            url={`${url}&utm_source=ok`}
            title={title}
            description={description}
            windowWidth={660}
            windowHeight={460}
            className="pointer"
          >
            <div>
              <OKIcon size={size} round />
            </div>
          </OKShareButton>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <WhatsappShareButton
            url={`${url}&utm_source=whatsapp`}
            title={title}
            windowWidth={660}
            windowHeight={460}
            className="pointer"
          >
            <div>
              <WhatsappIcon size={size} round />
            </div>
          </WhatsappShareButton>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <a
            href={`tg://msg_url?url=${encodeURIComponent(
              `${url}&utm_source=telegram`
            )}`}
          >
            <div>
              <TelegramIcon size={size} round />
            </div>
          </a>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ShareButton;
